import React, { useState, useEffect } from "react";
import { Switch, IconButton,  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit, Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteNotification, getNotifications, toggleNotificationStatus } from "../../../redux/actions/authActions";
import SearchBar from "../../../components/searchbar/SearchBar";

const NotificationDatatable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.auth.notifications);
  
  const [rows, setRows] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  // Sync internal rows with Redux store
  useEffect(() => {
    if (notifications) {
      setRows(notifications.map((n) => ({ ...n, id: n._id })));
    }
  }, [notifications]);

  const handleSearch = (inputValue) => {
    const filtered = notifications
      .filter((r) => r?.title.toLowerCase().includes(inputValue.toLowerCase()))
      .map((n) => ({ ...n, id: n._id }));
    setRows(filtered);
  };

  const handleToggleStatus = (id, currentStatus) => {
    const newStatus = !currentStatus;
    dispatch(toggleNotificationStatus(id, newStatus));
    // Optimistic UI update
    setRows((prev) => prev.map((r) => (r.id === id ? { ...r, status: newStatus } : r)));
  };

  const handleDelete = () => {
    dispatch(deleteNotification(deleteId));
    // Update local state so it disappears immediately without refresh
    setRows((prev) => prev.filter((r) => r.id !== deleteId));
    setOpen(false);
  };

  const columns = [
    { field: "createdAt", headerName: "Created On", width: 150, renderCell: (p) => new Date(p.value).toDateString() },
    { field: "title", headerName: "Notification Title", width: 200 },
    { field: "description", headerName: "Description", width: 300 },
    { field: "status", headerName: "Status", width: 120, renderCell: (p) => (
        <Switch checked={p.value || false} onChange={() => handleToggleStatus(p.row.id, p.value)} color="success" />
    )},
    { field: "manage", headerName: "Manage", width: 150, renderCell: (p) => (
        <div className="flex gap-2">
          <IconButton size="small" onClick={() => navigate(`/notifications/edit-notification/${p.row.id}`)}><Edit fontSize="small" /></IconButton>
          <IconButton size="small" color="error" onClick={() => { setDeleteId(p.row.id); setOpen(true); }}><Delete fontSize="small" /></IconButton>
        </div>
    )},
  ];

  return (
    <>
      <SearchBar titleOne="Add Notifications" onSearch={handleSearch} addClientPath="/notifications/add-notification" showAddButton={true} />
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mt-4">
        <div className="h-[500px]">
          <DataGrid
            rows={rows}
            columns={columns}
            disableRowSelectionOnClick
            pageSizeOptions={[5, 8, 10, 25]}
            initialState={{ pagination: { paginationModel: { pageSize: 8, page: 0 } } }}
            sx={{ border: "none", "& .MuiDataGrid-row.Mui-selected": { backgroundColor: "transparent" } }}
          />
        </div>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent><DialogContentText>Are you sure? This cannot be undone.</DialogContentText></DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} color="error">Delete</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NotificationDatatable;